<template>
    <div class="home">
        <div class="header">
            <p class="title">长三角农田土壤污染分布与健康风险评估系统</p>
            <div class="time">
                <el-dropdown size="small" @command="handleCommand">
                <span class="el-dropdown-link">
                    <i class="el-icon-s-custom"></i>{{ username }}
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="sjgl"><i class="el-icon-s-data"></i>
                    数据管理</el-dropdown-item>
                    <el-dropdown-item command="tcdl"><i class="el-icon-switch-button"></i>
                    退出登录</el-dropdown-item>
                </el-dropdown-menu>
                </el-dropdown>
            </div>

        </div>
        <div class="tabs"> 
            <div @click="changeTab('/HomeView/qygk','qygk')" :class="defaultTab == 'qygk'? 'active':''">区域概况</div>
            <div @click="changeTab('/HomeView/shjjzb','shjjzb')" :class="defaultTab == 'shjjzb'? 'active':''">社会经济指标</div>
            <div @click="changeTab('/HomeView/wrtz','wrtz')" :class="defaultTab == 'wrtz'? 'active':''">重金属污染特征及健康风险</div>
            <div @click="changeTab('/HomeView/jkfx','jkfx')" :class="defaultTab == 'jkfx'? 'active':''">多环芳烃污染特征及健康风险</div>
        </div>
        <div class="body">
            <router-view></router-view>
        </div>
    </div>
</template>
<script>

export default {
    data(){
        return{
            username:"admin",
            defaultTab:'qygk'
        }
    },
    methods:{
        // 切换tab页
        changeTab(path,name){
            this.defaultTab = name
            this.$router.push(path)
        },
        // 个人菜单点击事件
        handleCommand(value) {
        console.log(value)
        if (value == "tcdl") {
            this.$router.push("/Login")
            this.$message({
            message: '已退出',
            type: 'success'
            });
        } else if (value == "sjgl") {
            this.$router.push("/backGround")
        }
        },
    },
    mounted(){
        this.username = this.$Cookie.get("username")
        console.log(this.$route.path)
        if(this.$route.path == "/HomeView/wrtz"){
            this.defaultTab = "wrtz"
        }else if(this.$route.path == "/HomeView/qygk"){
            this.defaultTab = "qygk"
        }else if(this.$route.path == "/HomeView/shjjzb"){
            this.defaultTab = "shjjzb"
        }else if(this.$route.path == "/HomeView/jkfx"){
            this.defaultTab = "jkfx"
        }
    },
}
</script>
<style scoped lang="scss">
.home {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-image: url(../../imgs/0-bg.png);
  color: #fff;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
}
.header {
  display: flex;
  height: 60px;
  justify-content: center;
  position: relative;
  background-image: url(../../imgs/1-大标题.png);
  background-size: 100% 90px;

  padding-top: 15px;
  box-sizing: border-box;
}

.title {
  color: rgb(255, 255, 255);
  font-size: 26px;
  font-family: Arial;
  font-weight: 700;
  line-height: 36px;
}

.time {
  color: rgba(104, 187, 196, 1);
  position: absolute;
  right: 40px;
  bottom: 0;
  cursor: pointer;

  .el-dropdown-link {
    color: rgba(104, 187, 196, 1);
    font-size: 20px;
  }
}
.tabs{
    display: flex;
    justify-content: space-around;
    padding-bottom: 8px;
    // border-bottom: 1px solid rgba(104, 187, 196, 1);
    div{
        border: 1px solid rgb(5, 225, 250);
        width: 300px;
        text-align: center;
        line-height: 30px;
        font-size: 22px;
        border-radius: 15px;
        cursor: pointer;
    }
    div:hover{
        color:rgb(5, 225, 250) ;
    }
    .active{
        color:rgb(5, 225, 250) !important;
    }
}
.body{
    flex: 1;
}
</style>